/// <amd-module name="Repos/PipelineStatus/Components/PipelineStatus" />
import * as React from "react";
import { GitStatus, GitStatusState } from "Repos/Common/Contracts/Git";
import { PipelineStatusPanel } from "Repos/PipelineStatus/Components/PipelineStatusPanel";
import { getGitStatusStateProps, IGitStatusStateProps } from "Repos/PipelineStatus/Util/GitStatusState";
import { css } from "VSS/Platform/Layout";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";
import { Link } from "VSSUI/Link";
import { Status, StatusSize } from "VSSUI/Status";

export interface IPipelineStatusProps {
    className?: string;
    statuses?: GitStatus[];
}

const mapStateToPriority: { [key: number]: number } = {
    [GitStatusState.Error]: 1,
    [GitStatusState.Failed]: 2,
    [GitStatusState.Pending]: 3,
    [GitStatusState.Succeeded]: 4,
    [GitStatusState.NotSet]: 5,
    [GitStatusState.PartiallySucceeded]: 6,
};

export const PipelineStatus = (props: IPipelineStatusProps) => {
    const [displayStatusPanel, setDisplayPanelVisible] = React.useState(false);
    const status = getHighestPriorityState(props.statuses);
    if (!status) {
        return null;
    }

    const statusStateProps: IGitStatusStateProps = getGitStatusStateProps(status);
    return (
        <>
            <Link
                onClick={(event: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => {
                    setDisplayPanelVisible(!displayStatusPanel);
                    event.preventDefault();
                }}
                className={css("flex-row repos-pipeline-status scroll-hidden", props.className)}
                ariaLabel={status.description}
                excludeTabStop={true}
                removeUnderline={true}
            >
                <Status {...statusStateProps.statusProps} size={StatusSize.m} className="flex-self-center" />
                <span className={css("margin-left-8 text-ellipsis", statusStateProps.statusClass)}>{statusStateProps.statusText}</span>
            </Link>
            <ConditionalChildren renderChildren={displayStatusPanel}>
                <PipelineStatusPanel statuses={props.statuses} onDismiss={() => setDisplayPanelVisible(false)} />
            </ConditionalChildren>
        </>
    );
};

function getHighestPriorityState(statuses?: GitStatus[]): GitStatus | undefined {
    if (!statuses) {
        return undefined;
    }

    let previous: GitStatus | undefined = undefined;
    let result;
    for (const gs of statuses) {
        if (!previous || mapStateToPriority[gs.state] < mapStateToPriority[previous.state]) {
            result = gs;
        }

        previous = gs;
    }

    return result;
}
